import { NlpSettings } from '@feedyou/schema'
import { FormValidation } from '@rjsf/utils'

export function validateSchema(formData: NlpSettings, errors: FormValidation) {
  const someFeedyouModelHasAllLocale = formData?.models?.some(
    model => model.locale === 'all' && model.provider?.type === 'feedyou'
  )

  if (someFeedyouModelHasAllLocale) {
    errors.addError(
      `Locale "all" can only be set for models with descriptions. "intents with examples" provider only works with a specific locale.`
    )
  }

  return errors
}
